import React, { useState, useEffect } from 'react';
import Keycloak from 'keycloak-js';
import ThreatModeler from './pages/ThreatModeler';
import LandingPage from './pages/LandingPage';
import './App.css';

// Initialize Keycloak with debug logging
const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'threat-modeler',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'threat-modeler-ui'
};
console.log('Keycloak config:', keycloakConfig);

const keycloak = new Keycloak(keycloakConfig);

// Add event handlers for debugging
keycloak.onAuthSuccess = () => {
  console.log('Keycloak: Auth success!');
};
keycloak.onAuthError = (errorData) => {
  console.error('Keycloak: Auth error:', errorData);
};
keycloak.onAuthRefreshSuccess = () => {
  console.log('Keycloak: Token refresh success');
};
keycloak.onAuthRefreshError = () => {
  console.error('Keycloak: Token refresh error');
};
keycloak.onTokenExpired = () => {
  console.log('Keycloak: Token expired');
};

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [keycloakInstance, setKeycloakInstance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Initialize Keycloak without auto-redirect
    keycloak
      .init({
        pkceMethod: 'S256',
        checkLoginIframe: false
      })
      .then((authenticated) => {
        setAuthenticated(authenticated);
        setKeycloakInstance(keycloak);
        setLoading(false);

        // Clear any hash fragments from URL after authentication
        if (authenticated && window.location.hash) {
          window.history.replaceState(null, '', window.location.pathname);
        }

        // Refresh token every 60 seconds
        if (authenticated) {
          setInterval(() => {
            keycloak.updateToken(70).catch(() => {
              console.error('Failed to refresh token');
              keycloak.logout();
            });
          }, 60000);
        }
      })
      .catch((err) => {
        console.error('Keycloak initialization error:', err);
        console.error('Error type:', typeof err);
        console.error('Error details:', JSON.stringify(err, Object.getOwnPropertyNames(err || {})));
        // Don't show error for undefined - just show landing page
        if (err === undefined || err === false) {
          console.log('Keycloak init returned false/undefined, showing landing page');
          setAuthenticated(false);
          setKeycloakInstance(keycloak);
          setLoading(false);
        } else {
          setError('Failed to initialize authentication: ' + (err?.message || err));
          setLoading(false);
        }
      });
  }, []);

  const handleLogin = () => {
    keycloak.login();
  };

  const handleLogout = () => {
    keycloak.logout();
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Initializing authentication...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Authentication Error</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  if (!authenticated) {
    return <LandingPage onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <ThreatModeler
        keycloak={keycloakInstance}
        onLogout={handleLogout}
        user={{
          name: keycloakInstance.tokenParsed?.name || 'User',
          email: keycloakInstance.tokenParsed?.email || '',
          username: keycloakInstance.tokenParsed?.preferred_username || ''
        }}
      />
    </div>
  );
}

export default App;
